// extracted by mini-css-extract-plugin
export default {"root":"YoG5T7W1","block":"QPBD5zFS"};